var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSection3T1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.772949,
    y: 0.209473,
    width: 42.5553,
    height: 43.5047,
    rx: 2.007,
    fill: "#F0BB1F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0853 26.212H19.3596C19.1563 24.5562 17.7743 23.2703 16.1015 23.2703C14.2894 23.2703 12.8149 24.7785 12.8149 26.6322C12.8149 28.4859 14.2894 29.9942 16.1015 29.9942C17.7743 29.9942 19.1563 28.7082 19.3596 27.0525H23.0853C23.3125 27.0525 23.4961 26.8646 23.4961 26.6322C23.4961 26.3998 23.3125 26.212 23.0853 26.212Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9144 23.2607C27.4331 23.2607 26.9783 23.3752 26.568 23.5751L25.0009 20.9465C24.8837 20.7496 24.636 20.6894 24.4477 20.8131C24.2599 20.936 24.2029 21.1957 24.3205 21.393L25.8868 24.0199C25.1651 24.6377 24.703 25.5766 24.703 26.6275C24.703 28.4838 26.1437 29.9942 27.9144 29.9942C29.6851 29.9942 31.1257 28.4838 31.1257 26.6275C31.1257 24.7711 29.6851 23.2607 27.9144 23.2607Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7895 13.1843C20.0079 13.1843 18.5583 14.7065 18.5583 16.5773C18.5583 17.6363 19.0232 18.5825 19.749 19.2051L18.2158 21.7808C18.0974 21.9797 18.1552 22.2414 18.3438 22.3653C18.4105 22.4094 18.4848 22.4297 18.5575 22.4297C18.692 22.4297 18.8237 22.3593 18.9004 22.2304L20.4348 19.653C20.8476 19.8549 21.3052 19.9703 21.7895 19.9703C23.5712 19.9703 25.0208 18.4481 25.0208 16.5773C25.0208 14.7065 23.5712 13.1843 21.7895 13.1843Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSection3T1);
export default __webpack_public_path__ + "static/media/section3t1.4a717a80d415604c62d329cbb42e0f70.svg";
export { ForwardRef as ReactComponent };